import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class SsoService {
  async fetchSsoConfigs(): Promise<any> {
    return CaiApi.get(API_CORE.name, API_CORE.URLs.Sso.ssoConfig, {});
  }
}
